<template>
    <div style="height: 100%" class="pa-4">
        <v-row justify="space-between" class="mb-4">
            <v-col v-if="!noHeader">
                <div class="font-weight-bold basic--text text-center">
                    {{ "Scratch Card Details Entry".toUpperCase() }}
                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataValid">
            <v-alert type="warning" class="mt-4">
                Do ensure to enter the card details accurately as any further modification will not be allowed. Also
                note that providing wrong details might likely disqualify you
            </v-alert>
            <v-form v-model="dataValid">
                <v-sheet outlined rounded v-for="(item, index) in getSSCEs" :key="item.id" class="mb-2">
                    <div class="d-flex justify-space-between py-2">
                        <div class="my-auto ml-4 font-weight-bold">
                            {{ item.organization.title }} - {{ item.examType.title }}
                        </div>
                    </div>
                    <v-row class="px-4">
                        <v-col cols="12" sm="12" md="6">
                            <v-text-field :rules="textRules" outlined dense :disabled="hasScratchCards" label="Pin"
                                v-model="cards[index].pin"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                            <v-text-field outlined dense :disabled="hasScratchCards" label="Serial number"
                                v-model="cards[index].serialNumber"></v-text-field>
                        </v-col>
                    </v-row>
                </v-sheet>
            </v-form>
        </v-form>
        <v-card-actions class="mt-6">
            <v-spacer></v-spacer>
            <v-btn color="basic" class="white--text" @click="$emit('back')" depressed>{{ noHeader ? 'Back' : "Previous"
            }}</v-btn>
            <v-btn color="primary" depressed :disabled="!dataValid || hasScratchCards" @click="process"
                v-if="!hasScratchCards" :loading="loading">{{ noHeader ? 'Save' : 'Proceed' }}</v-btn>
            <v-btn color="info" depressed @click="success" v-if="hasScratchCards">Skip</v-btn>
        </v-card-actions>
        <loading-dialog :show="loading"></loading-dialog>
        <message-box :show="messageShow" :message="message" :type="messageType"
            v-on:close-message="messageShow = !messageShow"></message-box>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Api from "@/main/api";
import ErrorResolver from "@/shared/ErrorResolver";
import MessageBox from "@ui/components/MessageBox";
import ValidationRules from "@/shared/ValidationRules";
import LoadingDialog from "@ui/components/LoadingDialog";
import {
    getManualScratchCardSSCEs,
    hasCompletedScratchCardPin,
    hasCompletedScratchCardSSCE
} from "@/application/lib/scratchCardEntry";

export default {
    name: "ScratchCardManual",
    props: {
        noHeader: Boolean
    },
    components: { LoadingDialog, MessageBox },
    data: () => ({
        dataValid: true,
        messageType: "",
        message: "",
        messageShow: false,
        loading: false,
        textRules: [
            ...ValidationRules.textRules,
            value => hasCompletedScratchCardPin(value) || "Pin is required"
        ],
        cards: []
    }),

    methods: {
        success() {
            this.$emit("success");
        },

        process() {
            if (this.getUser == null)
                return

            if (this.cards.some(card => !hasCompletedScratchCardPin(card.pin))) {
                this.messageType = "error"
                this.message = "Pin is required"
                this.messageShow = true
                return
            }

            this.loading = true;
            let fd = new FormData();
            // copy required
            let d = [];
            for (let i = 0; i < this.cards.length; i++) d.push(this.cards[i]);

            const json = JSON.stringify(d);
            const blob = new Blob([json], {
                type: "application/json",
            });

            fd.append("cards", blob);
            fd.append("applicant", this.getUser.id)
            Api.scratchCard.updateNew(fd)
                .then(res => {
                    this.messageType = "success"
                    this.message = "Details uploaded"
                    this.messageShow = true
                    // update state
                    this.$store.commit("setScratchCards", res.data);

                    // reload
                    window.location.reload()
                }).catch(err => ErrorResolver.checkErrors(this, err))
                .finally(this.loading = false)
        }
    },

    computed: {
        ...mapGetters(["getSSCEDetails", "getUser"]),

        hasScratchCards: function () {
            return this.getSSCEs.length === 0
                || this.getSSCEs.every(hasCompletedScratchCardSSCE)
        },

        getSSCEs: function () {
            return getManualScratchCardSSCEs(this.getSSCEDetails)
        }
    },

    watch: {
        getSSCEs: {
            immediate: true,
            handler(ssces) {
                this.cards = ssces.map(ssce => ({
                    ssce: ssce.id,
                    pin: ssce.scratchCardPin || "",
                    serialNumber: ssce.scratchCardSerialNumber || ""
                }))
            }
        }
    },

    created() {
        this.noHeader && this.$emit('update-title', "Scratch cards")
    }
}
</script>

<style scoped></style>
